import { MediaType } from '../../../../types/general.types';
import { ProductMedia } from '../../ProductTypes';
import useKitDetailsList from '../components/KitDetailsList/hooks/useKitDetailsList';
import { KitCombinationTypes } from '../types/kit-combinations.types';

const KIT_ITEM_MEDIA_ID_PREFIX = 'kit-item-media';

const useKitDetailsMedias = (kitMedias: ProductMedia[]) => {
  const { combinations } = useKitDetailsList();

  const usedUrls = new Set(kitMedias.map((media) => media.url));
  const itemMedias: ProductMedia[] = [];

  combinations.forEach((combination) => {
    if (combination.type !== KitCombinationTypes.KIT_ITEM || !combination.mediaUrl) {
      return;
    }

    if (usedUrls.has(combination.mediaUrl)) {
      return;
    }

    usedUrls.add(combination.mediaUrl);
    itemMedias.push({
      id: `${KIT_ITEM_MEDIA_ID_PREFIX}-${combination.productColorId}`,
      type: MediaType.IMAGE,
      url: combination.mediaUrl,
      position: kitMedias.length + itemMedias.length,
      processed: true,
    });
  });

  return [...kitMedias, ...itemMedias];
};

export default useKitDetailsMedias;
